export const EXPANDABLE_INDICATOR_WIDTH = 8;
export const BAR_GAP_WIDTH = 2;
export const BORDER_WIDTH = 2;
